import { TripCategory } from "@overrides/types";
import { createAsyncThunk } from "@reduxjs/toolkit";
import type { FlightState } from "../../../types";
import { FlightShopActions } from "../slice";
import type { PricingMode } from "../types";
import { fetchFlights } from "./fetchFlights";
import { fetchMulticityFlights } from "./fetchMulticityFlights";

export const togglePricingMode = createAsyncThunk<
  void,
  { pricingMode: PricingMode; tripCategory: TripCategory },
  { state: FlightState }
>(
  "flightsShop/togglePricingMode",
  async ({ pricingMode, tripCategory }, thunkAPI) => {
    const state = thunkAPI.getState();

    if (tripCategory === TripCategory.MULTI_CITY) {
      const fixedPricingMulticityFlights =
        state.flights.flightShop.fixedPricingMulticityFlights;
      const flexPricingMulticityFlights =
        state.flights.flightShop.flexPricingMulticityFlights;

      if (pricingMode === "fixed" && !fixedPricingMulticityFlights) {
        thunkAPI.dispatch(
          fetchMulticityFlights({ searchFixedPointsFares: true })
        );
      } else if (pricingMode === "flex" && !flexPricingMulticityFlights) {
        thunkAPI.dispatch(
          fetchMulticityFlights({ searchFixedPointsFares: false })
        );
      }
    } else {
      const fixedPricingFlights = state.flights.flightShop.fixedPricingFlights;
      const flexPricingFlights = state.flights.flightShop.flexPricingFlights;
      if (pricingMode === "fixed" && !fixedPricingFlights) {
        thunkAPI.dispatch(fetchFlights({ searchFixedPointsFares: true }));
      } else if (pricingMode === "flex" && !flexPricingFlights) {
        thunkAPI.dispatch(fetchFlights({ searchFixedPointsFares: false }));
      }
    }

    thunkAPI.dispatch(
      FlightShopActions.setPricingMode({ pricingMode, tripCategory })
    );
  }
);
